import React from 'react';
import { Card, Typography, Space, Tag, Divider } from 'antd';
import { BookOutlined, InfoCircleOutlined } from '@ant-design/icons';

const { Title, Text, Paragraph } = Typography;

const Documentation: React.FC = () => {
  return (
    <div style={{ padding: '24px' }}>
      <Card>
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <div>
            <Title level={3}>
              <BookOutlined style={{ marginRight: 8 }} />
              Documentation
            </Title>
            <Tag color="green">Upcoming Feature</Tag>
          </div>
          
          <Divider />
          
          <div>
            <Title level={4}>User Guide & Manuals</Title>
            <Paragraph>
              This page will contain comprehensive documentation and user guides.
              Features will include:
            </Paragraph>
            <ul>
              <li>Getting started guide for new users</li>
              <li>Feature tutorials and walkthroughs</li>
              <li>API documentation and integration guides</li>
              <li>Best practices and tips</li>
              <li>Video tutorials and screenshots</li>
            </ul>
          </div>
          
          <div style={{ 
            background: '#f6ffed', 
            padding: '16px', 
            borderRadius: '8px',
            border: '1px solid #b7eb8f'
          }}>
            <Space>
              <InfoCircleOutlined style={{ color: '#52c41a' }} />
              <Text type="secondary">
                Comprehensive documentation will be available to help you get the most out of the system.
              </Text>
            </Space>
          </div>
        </Space>
      </Card>
    </div>
  );
};

export default Documentation;
